var React = require('react');

function NavIconsHelp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m12 22a10 10 0 1 1 10-10 10 10 0 0 1 -10 10zm0-18.93a8.93 8.93 0 1 0 8.93 8.93 8.95 8.95 0 0 0 -8.93-8.93z","key":0}),React.createElement("path",{"d":"m10.93 15.09v-1.62c0-1.39.55-2.06 2.09-2.06h.35c1.2 0 1.47-.39 1.47-1.38v-1.2c0-1-.27-1.41-1.47-1.41h-2.74c-1.2 0-1.47.4-1.47 1.41v.75l-1-.29v-.62c0-1.51.66-2.15 2.34-2.15h2.95c1.68 0 2.39.67 2.39 2.16v1.49c0 1.49-.64 2.13-2.12 2.13h-.33c-1.21 0-1.46.39-1.46 1.4v1.39zm-.16 2.39v-1.23h1.32v1.23z","key":1})]);
}

NavIconsHelp.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsHelp;

NavIconsHelp.default = NavIconsHelp;
